<div class="modal-header border-0">
  <p class="fs-20 fw-800 color-gray-950 mb-0">{{'agenda.new_appointment'|translate}}</p>
  <a class="clickable color-gray-400" (click)="modal.dismiss()" [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
</div>

<div class="modal-body pt-0">
  <p class="fs-normal fw-500 color-gray-500">
    {{startsAt.format('D MMMM dddd')}} · {{startsAt.format('HH:mm')}}
  </p>

  <form [formGroup]="fg" (ngSubmit)="onSubmit()">

    <div class="mt-3">
      <label class="color-gray-500 fw-500 fs-normal">{{'agenda.student'|translate}}</label>
      <app-gray-select-input
        [items]="students" bindLabel="name" bindValue="id" [searchable]="true"
        [hasError]="isSubmitted && fg.get('studentId')?.invalid"
        [placeholder]="'agenda.select_student'|translate"
        (changed)="onStudentChanged($event)"
        formControlName="studentId"></app-gray-select-input>
      <div class="form-errors mt-1" *ngIf="isSubmitted && fg.get('studentId')?.errors">
        <p>{{'errors.required'|translate}}</p>
      </div>
    </div>

    <p class="fs-small fw-500 color-gray-400 mt-2 mb-0" *ngIf="weeklyStatus">
      {{'agenda.weekly_usage'|translate: {used: weeklyStatus.used, limit: weeklyStatus.limit ?? '∞'} }}
    </p>

    <div class="mt-3">
      <label class="color-gray-500 fw-500 fs-normal">{{'agenda.appointment_title'|translate}}</label>
      <app-gray-text-input
        [hasErr]="isSubmitted && fg.get('title')?.invalid"
        [placeholder]="'agenda.appointment_title_placeholder'|translate"
        formControlName="title"></app-gray-text-input>
      <div class="form-errors mt-1" *ngIf="isSubmitted && fg.get('title')?.errors">
        <p>{{'errors.required'|translate}}</p>
      </div>
    </div>

    <div class="mt-3">
      <label class="color-gray-500 fw-500 fs-normal">{{'agenda.appointment_notes'|translate}}</label>
      <textarea
        class="modal-textarea w-100" formControlName="notes"
        [placeholder]="'agenda.appointment_notes_placeholder'|translate"></textarea>
    </div>

    <div class="form-errors mt-3" *ngIf="errKey">
      <p>{{errKey|translate}}</p>
    </div>

    <div class="row mt-4">
      <div class="col-6">
        <app-gray-button
          type="button" color="stroke-gray" [weight]="500" customClass="fs-normal" [text]="'buttons.give_up'|translate"
          (click)="modal.dismiss()"></app-gray-button>
      </div>
      <div class="col-6">
        <app-gray-button
          type="submit" color="primary" [weight]="500" customClass="fs-normal" [isLoading]="isLoading" [disabled]="isLoading"
          [text]="'buttons.save'|translate"></app-gray-button>
      </div>
    </div>

  </form>
</div>
